import { RoleForm } from '@cms/components/forms/RoleForm';
import { generateSearchParam } from '@cms/utils/helpers';
import { ISystemRole } from '@dl/declarations';
import clsx from 'clsx';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { DataPart } from '../../components/ui/DataPart';
import PageContainer from '../../components/ui/PageContainer';
import { renderRouteOptions, RolesPath, Routes } from '../../utils/routes';


const RolesPage = () => {
    const renderItem = useCallback((item: ISystemRole) => {
        return (
            <Link
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'flex items-center gap-2',
                    'border border-cs-700 rounded-md',
                )}
                to={{
                    pathname: Routes.ROLES,
                    search: `?${generateSearchParam(RolesPath, "mode", "update")}&${generateSearchParam(RolesPath, "id", item._id)}`,
                }}
                key={item._id}
            >
                <h4 className='w-full max-w-1/2 text-cs-600 font-semibold'>{item.name}</h4>
            </Link>
        )
    }, [])

    return (
        <PageContainer
            title={renderRouteOptions(Routes.ROLES).title}
        >
            <DataPart<ISystemRole>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    noOfColumns: "1",
                    renderItem: renderItem,
                }}

                queryOptions={{
                    basePath: RolesPath,
                }}

                filters={{}}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true,
                }}
                searchOptions={{
                    allow: true
                }}

                form={<RoleForm />}
            />
        </PageContainer>
    )
}

export default RolesPage